module.exports = __webpack_public_path__ + "static/img/bg.616f8671.jpg";